export default function StatementCard({ text }: { text: string }) {
  return (
    <div className="animate-scale-in rounded-card bg-vm-primary-soft p-5 [animation-delay:150ms]">
      <svg
        aria-hidden
        className="mb-3 h-6 w-6 text-vm-primary"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M9.6 6C6.5 7.3 4.5 10 4.5 13.4V18h5.6v-5.6H7.3c.1-1.9 1.2-3.5 3.2-4.4L9.6 6Zm9 0c-3.1 1.3-5.1 4-5.1 7.4V18h5.6v-5.6h-2.8c.1-1.9 1.2-3.5 3.2-4.4L18.6 6Z" />
      </svg>
      <p className="text-lg font-semibold leading-snug text-vm-ink">{text}</p>
    </div>
  )
}
